// 类型相关

// 申请人角色类型
export const applicantRoleTypeList = [
  {
    value: "DIRECTOR",
    zh: "拟设公司/基金董事",
    en: "Director of the proposed company/fund",
  },
  {
    value: "SHAREHOLDER",
    zh: "拟设公司/基金的直接股东",
    en: "Direct shareholder of the proposed company/fund",
  },
  {
    value: "INDIRECT_SHAREHOLDER",
    zh: "拟设公司/基金的间接/最终股东",
    en: "Intermediary/ultimate shareholder of the proposed company/fund",
  },
  { value: "OTHER", zh: "其他", en: "Other" },
];
// 公司类型
export const companyTypeList = [
  {
    value: "Exempt Private Company Limited by Shares",
    zh: "Exempt Private Company Limited by Shares / 豁免私人股份有限公司",
    en: "Exempt Private Company Limited by Shares",
  },
  {
    value: "Private Company Limited by Shares",
    zh: "Private Company Limited by Shares / 股份制私人有限公司",
    en: "Private Company Limited by Shares",
  },
  // {
  //   value: "Public Company Limited By Gurantee",
  //   zh: "Public Company Limited By Gurantee / � 担保人公共有限公司",
  //   en: "Public Company Limited By Gurantee"
  // },
  // {
  //   value: "Public Company Limited By Shares",
  //   zh: "Public Company Limited By Shares / 公共股份有限公司",
  //   en: "Public Company Limited By Shares"
  // },
  // {
  //   value: "Unlimited Exempt Private Company",
  //   zh: "Unlimited Exempt Private Company / 无限豁免私人公司",
  //   en: "Unlimited Exempt Private Company"
  // },
  // {
  //   value: "Unlimited Private Company",
  //   zh: "Unlimited Private Company / 无限私人公司",
  //   en: "Unlimited Private Company"
  // },
  // {
  //   value: "Unlimited Public Company",
  //   zh: "Unlimited Public Company / 无限公共公司",
  //   en: "Unlimited Public Company"
  // }
];
// 公司类型对应的后缀类型
export const companySuffixTypeList = {
  "Exempt Private Company Limited by Shares": [
    "PRIVATE LIMITED",
    "PRIVATE LTD.",
    "PTE. LIMITED",
    "PTE. LTD.",
    "SDN. BERHAD",
    "SDN. BHD.",
    "SENDIRIAN BERHAD",
    "SENDIRIAN BHD.",
    "(PRIVATE LIMITED)",
    "(PRIVATE LTD.)",
    "(PTE. LIMITED)",
    "(PTE. LTD.)",
    "(PTE.) LIMITED",
    "(PTE.) LTD.",
    "(SDN. BERHAD)",
    "(SDN. BHD.)",
    "(SDN.) BERHAD",
    "(SDN.) BHD.",
    "(SENDIRIAN BERHAD)",
    "(SENDIRIAN BHD.)",
    "(SENDIRIAN) BERHAD",
    "(SENDIRIAN) BHD.",
  ],

  "Private Company Limited by Shares": [
    "PRIVATE LIMITED",
    "PRIVATE LTD.",
    "PTE. LIMITED",
    "PTE. LTD.",
    "SDN. BERHAD",
    "SDN. BHD.",
    "SENDIRIAN BERHAD",
    "SENDIRIAN BHD.",
    "(PRIVATE LIMITED)",
    "(PRIVATE LTD.)",
    "(PTE. LIMITED)",
    "(PTE. LTD.)",
    "(PTE.) LIMITED",
    "(PTE.) LTD.",
    "LAW CORPORATION",
    "LLC",
    // "PAC",
    "(LAW CORPORATION)",
    "(LLC)",
    "(PAC)",
    "(SDN. BERHAD)",
    "(SDN. BHD.)",
    "(SDN.) BERHAD",
    "(SDN.) BHD.",
    "(SENDIRIAN BERHAD)",
    "(SENDIRIAN BHD.)",
    "(SENDIRIAN) BERHAD",
    "(SENDIRIAN) BHD.",
  ],

  "Public Company Limited By Gurantee": ["BERHAD", "BHD.", "LIMITED", "LTD.", "(BERHAD)", "(BHD.)", "(LIMITED)", "(LTD.)"],
  "Public Company Limited By Shares": ["BERHAD", "BHD.", "LIMITED", "LTD.", "(BERHAD)", "(BHD.)", "(LIMITED)", "(LTD.)"],

  "Unlimited Exempt Private Company": ["PRIVATE", "PTE.", "SDN.", "SENDIRIAN", "(PRIVATE)", "(PTE.)", "(SDN.)", "(SENDIRIAN)"],
  "Unlimited Private Company": ["PRIVATE", "PTE.", "SDN.", "SENDIRIAN", "(PRIVATE)", "(PTE.)", "(SDN.)", "(SENDIRIAN)"],

  "Unlimited Public Company": ["UNLIMITED", "(UNLIMITED)"],
};
// 股票类型
export const stockList = [
  {
    value: "Ordinary",
    zh: "Ordinary 普通股",
    en: "Ordinary",
  },
  {
    value: "Preference",
    zh: "Preference 优先股",
    en: "Preference",
  },
  {
    value: "Others",
    zh: "Others 其他",
    en: "Others",
  },
];
// 投资类型
export const investmentTypeList = [
  {
    value: "Shares from open market",
    zh: "Shares from open market 公开市场的股份",
    en: "Shares from open market",
  },
  {
    value: "Shares from off market",
    zh: "Shares from off market 非公开市场的股份",
    en: "Shares from off market",
  },
  {
    value: "Shares from open and off market",
    zh: "Shares from open and off market 公开市场和非公开市场的股份",
    en: "Shares from open and off market",
  },
  {
    value: "Financial derivatives from open market",
    zh: "Financial derivatives from open market 公开市场的金融衍生品",
    en: "Financial derivatives from open market",
  },
  {
    value: "Financial derivatives from off market",
    zh: "Financial derivatives from off market 非公开市场的金融衍生品",
    en: "Financial derivatives from off market",
  },
  {
    value: "Financial derivatives from open and off market",
    zh: "Financial derivatives from open and off market 公开市场和非公开市场的金融衍生品",
    en: "Financial derivatives from open and off market",
  },
  { value: "Bonds", zh: "Bonds 债券", en: "Bonds" },
  { value: "Property", zh: "Property 房地产", en: "Property" },
  {
    value: "Cash (e.g. term deposit, interest saving accounts)",
    zh: "Cash (e.g. term deposit, interest saving accounts) 现金 (例: 定期存款, 活期存款)",
    en: "Cash (e.g. term deposit, interest saving accounts)",
  },
  {
    value: "Other assets except property/cash",
    zh: "Other assets except property/cash 非房地产/现金类的其他资产",
    en: "Other assets except property/cash",
  },
  { value: "Others", zh: "Others 其他", en: "Others" },
];
// 基金类型
export const fundTypeList = [
  {
    value: "Non-umbrella VCC",
    zh: "Non-umbrella VCC 单一 VCC 基金",
    en: "Non-umbrella VCC",
  },
  {
    value: "Umbrella VCC",
    zh: "Umbrella VCC 非单一 VCC 基金",
    en: "Umbrella VCC",
  },
  {
    value: "Sub-fund",
    zh: "Sub-fund 子基金",
    en: "Sub-fund",
  },
  {
    value: "Others",
    zh: "Others 其他",
    en: "Others",
  },
];
// 订单类型
export const orderTypeList = [
  {
    // 一般的
    value: "generic",
    zh: "普通订单",
    en: "Ordinary",
  },
  {
    // 补款单
    value: "amends",
    zh: "补款订单",
    en: "Supplemental",
  },
];
// 成员类型
export const memberTypeList = [
  {
    value: "CORPORATE",
    zh: "公司",
    en: "Company",
  },
  {
    value: "INDIVIDUAL",
    zh: "个人",
    en: "Individual",
  },
];
// 职位类型
export const positionHeldTypeList = [
  {
    value: "SHAREHOLDER",
    zh: "股东",
    en: "Shareholder",
  },
  {
    value: "DIRECTOR",
    zh: "董事",
    en: "Director",
  },
  {
    value: "DIRECTOR_AND_SHAREHOLDER",
    zh: "股东+董事",
    en: "Shareholder+Director",
  },
];

// 性别类型
export const genderTypeList = [
  {
    value: "Male",
    zh: "男",
    en: "Male",
  },
  {
    value: "Female",
    zh: "女",
    en: "Female",
  },
];
